import "./Fieldset.css";
import type { ParentComponent } from "solid-js";

type Props = {
	indentFields?: boolean;
	gap?: "medium" | "large";
	class?: string;
};

export const Fieldset: ParentComponent<Props> = (props) => {
	const indentFields = props.indentFields ?? true;
	const gap = props.gap ?? "medium";
	const fieldsetClass = `gvtui-fieldset ${indentFields ? "gvtui-fieldset--indented" : ""} gvtui-fieldset--gap-${gap} ${props.class ?? ""}`;
	return <fieldset class={fieldsetClass}>{props.children}</fieldset>;
};
